import { Service, Location, BlogPost, Project, Gallery, Lead, Review, StaticPage } from '@/types'

// Mock Services Data
export const mockServices: Service[] = [
  {
    id: '1',
    title: 'Brick Repair & Restoration',
    slug: 'brick-repair-restoration',
    description: 'Professional brick repair and restoration services for residential and commercial properties.',
    content: 'Comprehensive brick repair services including crack repair, brick replacement, repointing, and full restoration.',
    excerpt: 'Expert brick repair and restoration to restore your property\'s structural integrity and appearance.',
    hero_image: '/images/services/brick-repair-hero.jpg',
    gallery_images: ['/images/gallery/brick-repair-1.jpg', '/images/gallery/brick-repair-2.jpg'],
    benefits: [
      'Prevents water damage and structural issues',
      'Improves property value and curb appeal',
      'Uses traditional masonry techniques',
      'Matches existing brick and mortar'
    ],
    process_steps: [
      'Initial assessment and damage evaluation',
      'Careful removal of damaged bricks',
      'Proper preparation of the area',
      'Installation of matching bricks',
      'Repointing and finishing work'
    ],
    faq: [
      {
        question: 'How long does brick repair typically take?',
        answer: 'Most brick repair projects take 1-3 days depending on the extent of damage and weather conditions.'
      },
      {
        question: 'Do you match existing brick colors?',
        answer: 'Yes, we source bricks to match your existing masonry as closely as possible.'
      }
    ],
    status: 'published',
    featured: true,
    service_category: 'Masonry Repair',
    pricing_info: 'Contact for custom quote based on project scope',
    service_areas: ['Toronto', 'Hamilton', 'Burlington', 'Oakville'],
    seo: {
      meta_title: 'Professional Brick Repair Services | FixMyBrick',
      meta_description: 'Expert brick repair and restoration services. Professional masonry contractors with 20+ years experience.',
      focus_keyword: 'brick repair',
      canonical_url: '/services/brick-repair-restoration',
      og_title: 'Professional Brick Repair Services',
      og_description: 'Expert brick repair and restoration services. Professional masonry contractors.',
      schema_markup: JSON.stringify({
        "@type": "Service",
        "name": "Brick Repair & Restoration",
        "provider": "FixMyBrick"
      })
    },
    created_at: '2025-01-01T00:00:00Z',
    updated_at: '2025-06-10T00:00:00Z'
  },
  {
    id: '2',
    title: 'Tuckpointing Services',
    slug: 'tuckpointing-services',
    description: 'Professional tuckpointing to restore and maintain your masonry structures.',
    content: 'Expert tuckpointing services to repair mortar joints and prevent water infiltration.',
    excerpt: 'Professional tuckpointing services to maintain your masonry\'s structural integrity.',
    hero_image: '/images/services/tuckpointing-hero.jpg',
    status: 'published',
    featured: true,
    service_category: 'Masonry Maintenance',
    service_areas: ['Toronto', 'North York', 'Etobicoke'],
    seo: {
      meta_title: 'Professional Tuckpointing Services | FixMyBrick',
      meta_description: 'Expert tuckpointing services to restore mortar joints and prevent water damage.',
      focus_keyword: 'tuckpointing',
      canonical_url: '/services/tuckpointing-services'
    },
    created_at: '2025-01-15T00:00:00Z',
    updated_at: '2025-06-05T00:00:00Z'
  },
  {
    id: '3',
    title: 'Chimney Repair',
    slug: 'chimney-repair',
    description: 'Complete chimney repair and maintenance services for safe operation.',
    content: 'Comprehensive chimney repair including crown repair, flue liner installation, and structural repairs.',
    status: 'published',
    featured: false,
    service_category: 'Chimney Services',
    service_areas: ['Hamilton', 'Burlington', 'Stoney Creek'],
    seo: {
      meta_title: 'Chimney Repair Services | FixMyBrick',
      meta_description: 'Professional chimney repair and maintenance services for safe, efficient operation.',
      focus_keyword: 'chimney repair'
    },
    created_at: '2025-02-01T00:00:00Z',
    updated_at: '2025-05-20T00:00:00Z'
  }
]

// Mock Locations Data
export const mockLocations: Location[] = [
  {
    id: '1',
    name: 'Toronto Central',
    slug: 'toronto-central',
    city: 'Toronto',
    province: 'Ontario',
    address: '123 King Street West',
    postal_code: 'M5H 1A1',
    phone: '(416) 555-0100',
    email: 'toronto@fixmybrick.ca',
    description: 'Serving downtown Toronto and surrounding areas with professional masonry services.',
    is_primary: true,
    status: 'active',
    service_ids: ['1', '2', '3'],
    seo: {
      meta_title: 'Masonry Services Toronto | FixMyBrick',
      meta_description: 'Professional masonry and brick repair services in Toronto. 20+ years experience.',
      focus_keyword: 'masonry Toronto'
    },
    created_at: '2025-01-01T00:00:00Z',
    updated_at: '2025-06-01T00:00:00Z'
  },
  {
    id: '2',
    name: 'Hamilton',
    slug: 'hamilton',
    city: 'Hamilton',
    province: 'Ontario',
    phone: '(905) 555-0200',
    email: 'hamilton@fixmybrick.ca',
    description: 'Professional masonry services throughout Hamilton and the Greater Hamilton Area.',
    is_primary: false,
    status: 'active',
    service_ids: ['1', '2', '3'],
    seo: {
      meta_title: 'Masonry Services Hamilton | FixMyBrick',
      meta_description: 'Expert brick repair and masonry services in Hamilton, Ontario.',
      focus_keyword: 'masonry Hamilton'
    },
    created_at: '2025-01-10T00:00:00Z',
    updated_at: '2025-05-15T00:00:00Z'
  }
]

// Mock Blog Posts Data
export const mockBlogPosts: BlogPost[] = [
  {
    id: '1',
    title: 'Signs Your Brick Needs Professional Repair',
    slug: 'signs-brick-needs-repair',
    content: 'Learn the warning signs that indicate your brick masonry needs professional attention...',
    excerpt: 'Discover the key indicators that your brick structure requires professional repair services.',
    featured_image: '/images/blog/brick-damage-signs.jpg',
    author_id: 'admin-1',
    status: 'published',
    published_at: '2025-05-15T10:00:00Z',
    category_ids: ['cat-1'],
    tag_ids: ['tag-1', 'tag-2'],
    read_time: 5,
    seo: {
      meta_title: 'Signs Your Brick Needs Repair | FixMyBrick Blog',
      meta_description: 'Learn the warning signs that indicate your brick masonry needs professional repair.',
      focus_keyword: 'brick repair signs'
    },
    created_at: '2025-05-10T00:00:00Z',
    updated_at: '2025-05-15T00:00:00Z'
  }
]

// Mock Projects Data
export const mockProjects: Project[] = [
  {
    id: '1',
    title: 'Historic Downtown Toronto Building Restoration',
    slug: 'historic-toronto-building-restoration',
    description: 'Complete restoration of a 1920s heritage brick building in downtown Toronto.',
    content: 'This challenging project involved restoring the original brick facade while meeting modern building codes...',
    featured_image: '/images/projects/historic-building-after.jpg',
    gallery_images: [
      '/images/projects/historic-building-1.jpg',
      '/images/projects/historic-building-2.jpg'
    ],
    service_id: '1',
    location_id: '1',
    client_name: 'Heritage Properties Inc.',
    project_date: '2024-08-15',
    project_duration: '6 weeks',
    project_value: 85000,
    status: 'published',
    before_images: ['/images/projects/historic-building-before-1.jpg'],
    after_images: ['/images/projects/historic-building-after-1.jpg'],
    seo: {
      meta_title: 'Historic Building Restoration Toronto | FixMyBrick Projects',
      meta_description: 'Case study of heritage brick building restoration in downtown Toronto.',
      focus_keyword: 'building restoration Toronto'
    },
    created_at: '2024-09-01T00:00:00Z',
    updated_at: '2025-01-15T00:00:00Z'
  }
]

// Mock Leads Data
export const mockLeads: Lead[] = [
  {
    id: '1',
    first_name: 'John',
    last_name: 'Smith',
    email: 'john.smith@email.com',
    phone: '(416) 555-1234',
    address: '456 Main Street',
    city: 'Toronto',
    province: 'Ontario',
    postal_code: 'M4Y 1W2',
    service_interest: ['Brick Repair & Restoration'],
    location_id: '1',
    message: 'I have some damaged bricks on the front of my house that need repair.',
    source: 'website',
    status: 'new',
    priority: 'medium',
    estimated_value: 2500,
    created_at: '2025-06-09T14:30:00Z',
    updated_at: '2025-06-09T14:30:00Z'
  },
  {
    id: '2',
    first_name: 'Sarah',
    last_name: 'Johnson',
    email: 'sarah.j@email.com',
    phone: '(905) 555-5678',
    city: 'Hamilton',
    service_interest: ['Tuckpointing Services'],
    message: 'Need tuckpointing work on my century home.',
    source: 'google_ads',
    status: 'contacted',
    priority: 'high',
    assigned_to: 'admin-1',
    follow_up_date: '2025-06-12',
    estimated_value: 4200,
    created_at: '2025-06-08T09:15:00Z',
    updated_at: '2025-06-10T11:00:00Z'
  }
]

// Mock Reviews Data
export const mockReviews: Review[] = [
  {
    id: '1',
    author_name: 'Michael Thompson',
    rating: 5,
    title: 'Outstanding brick repair work',
    content: 'FixMyBrick did an amazing job repairing the brick on our heritage home. Professional, clean, and the results exceeded our expectations.',
    service_id: '1',
    location_id: '1',
    source: 'google',
    external_url: 'https://google.com/reviews/123',
    status: 'published',
    is_featured: true,
    created_at: '2025-05-20T00:00:00Z',
    updated_at: '2025-05-20T00:00:00Z'
  },
  {
    id: '2',
    author_name: 'Lisa Chen',
    rating: 5,
    content: 'Excellent tuckpointing service. Very professional team and great attention to detail.',
    service_id: '2',
    source: 'website',
    status: 'published',
    is_featured: false,
    created_at: '2025-05-18T00:00:00Z',
    updated_at: '2025-05-18T00:00:00Z'
  }
]

// Mock Static Pages Data
export const mockStaticPages: StaticPage[] = [
  {
    id: '1',
    title: 'About FixMyBrick',
    slug: 'about',
    content: 'FixMyBrick has been providing professional masonry services for over 20 years. Our team of skilled craftsmen specializes in brick repair, restoration, and maintenance services across Ontario.',
    excerpt: 'Learn about our 20+ years of masonry expertise and commitment to quality craftsmanship.',
    template: 'about',
    featured_image: '/images/pages/about-hero.jpg',
    status: 'published',
    menu_order: 1,
    is_homepage: false,
    show_in_nav: true,
    custom_fields: {
      founder_name: 'James Thompson',
      years_experience: 20,
      team_size: 15,
      certifications: ['Ontario Masonry Association', 'Better Business Bureau A+']
    },
    seo: {
      meta_title: 'About FixMyBrick - Professional Masonry Contractors Ontario',
      meta_description: 'Learn about FixMyBrick\'s 20+ years of masonry expertise. Professional brick repair and restoration services across Ontario.',
      focus_keyword: 'professional masonry contractors',
      canonical_url: '/about'
    },
    created_at: '2025-01-01T00:00:00Z',
    updated_at: '2025-06-01T00:00:00Z'
  },
  {
    id: '2',
    title: 'Contact Us',
    slug: 'contact',
    content: 'Get in touch with our masonry experts for a free consultation and quote. We serve the Greater Toronto Area and Hamilton region.',
    template: 'contact',
    status: 'published',
    menu_order: 5,
    is_homepage: false,
    show_in_nav: true,
    custom_fields: {
      contact_form_id: 'contact-form-1',
      office_hours: 'Monday-Friday 8AM-6PM',
      emergency_contact: '(416) 555-0911',
      service_areas: ['Toronto', 'Hamilton', 'Burlington', 'Oakville']
    },
    seo: {
      meta_title: 'Contact FixMyBrick - Free Masonry Consultation',
      meta_description: 'Contact our masonry experts for a free consultation. Serving Toronto, Hamilton, and surrounding areas.',
      focus_keyword: 'contact masonry contractors',
      canonical_url: '/contact'
    },
    created_at: '2025-01-01T00:00:00Z',
    updated_at: '2025-05-15T00:00:00Z'
  },
  {
    id: '3',
    title: 'Welcome to FixMyBrick',
    slug: 'home',
    content: 'Professional masonry services you can trust. From brick repair to complete restoration, our skilled craftsmen deliver exceptional results.',
    template: 'landing',
    featured_image: '/images/pages/home-hero.jpg',
    status: 'published',
    menu_order: 0,
    is_homepage: true,
    show_in_nav: false,
    custom_fields: {
      hero_heading: 'Professional Masonry Services You Can Trust',
      hero_subheading: 'Expert brick repair, restoration, and maintenance across Ontario',
      cta_text: 'Get Free Quote',
      cta_link: '/contact',
      featured_services: ['1', '2', '3'],
      testimonials_section: true
    },
    seo: {
      meta_title: 'FixMyBrick - Professional Masonry & Brick Repair Services Ontario',
      meta_description: 'Professional masonry contractors with 20+ years experience. Expert brick repair, restoration, and tuckpointing services in Toronto & Hamilton.',
      focus_keyword: 'masonry contractors Ontario',
      canonical_url: '/'
    },
    created_at: '2025-01-01T00:00:00Z',
    updated_at: '2025-06-08T00:00:00Z'
  },
  {
    id: '4',
    title: 'Privacy Policy',
    slug: 'privacy-policy',
    content: 'This privacy policy describes how FixMyBrick collects, uses, and protects your personal information when you use our services.',
    template: 'legal',
    status: 'published',
    menu_order: 99,
    is_homepage: false,
    show_in_nav: false,
    seo: {
      meta_title: 'Privacy Policy - FixMyBrick',
      meta_description: 'FixMyBrick privacy policy and data protection information.',
      canonical_url: '/privacy-policy'
    },
    created_at: '2025-01-01T00:00:00Z',
    updated_at: '2025-03-15T00:00:00Z'
  },
  {
    id: '5',
    title: 'Service Areas',
    slug: 'service-areas',
    content: 'We proudly serve the Greater Toronto Area and Greater Hamilton Area with professional masonry services.',
    template: 'default',
    status: 'draft',
    menu_order: 2,
    is_homepage: false,
    show_in_nav: true,
    custom_fields: {
      map_enabled: true,
      service_radius: 50,
      primary_areas: ['Toronto', 'Hamilton', 'Burlington', 'Oakville', 'Mississauga'],
      secondary_areas: ['Brampton', 'North York', 'Etobicoke', 'Stoney Creek']
    },
    seo: {
      meta_title: 'Service Areas - FixMyBrick Masonry Services',
      meta_description: 'Professional masonry services across the Greater Toronto Area and Greater Hamilton Area.',
      focus_keyword: 'masonry services Toronto Hamilton',
      canonical_url: '/service-areas'
    },
    created_at: '2025-02-01T00:00:00Z',
    updated_at: '2025-06-05T00:00:00Z'
  }
]